import { PriorAuthHttp } from "../PriorAuthHttp";
import { urls } from "../Urls";

/** X12 admin APIs — Bearer + ClientId are attached by PriorAuthHttp. */
export class EdiConfigApi {
  static getClient() {
    return PriorAuthHttp.get(urls.edi.client);
  }

  static getExplorer() {
    return PriorAuthHttp.get(urls.edi.explorer);
  }

  static getOverrides() {
    return PriorAuthHttp.get(urls.edi.overrides);
  }

  static saveOverrides(payload: object) {
    return PriorAuthHttp.put(urls.edi.overrides, payload);
  }
}
